import { Button } from '../../inputs/button.component';

interface BodyConfirmModalProps {
  children?: JSX.Element;
  confirmText?: string;
  canConfirm?: boolean;
  color?: string;
  colorHover?: string;
  onCancel: () => void
  onConfirm: () => void;
  t: ( key: string ) => string;
}


export function BodyConfirmModal( { children, canConfirm, onConfirm, onCancel, confirmText, t, color = '#f87171', colorHover = '#ef4444' }: BodyConfirmModalProps ) {

  return (
    <>
      <>
        { children }
      </>
      <div className='flex justify-end items-center w-full mt-4'>
        <div className='w-[30%]'>
          <Button
            color='#FFFFFF'
            colorHover='#F4F4F4'
            textColor='#000000'
            borderColor='#D9D9D9'
            label={ t( 'common:cancel' ) }
            onClick={ onCancel }
          />
        </div>
        <div className='w-[30%]'>
          <Button
            disable={ canConfirm }
            color={ color }
            colorHover={ colorHover }
            label={ confirmText ?? t( 'common:confirm' ) }
            onClick={ onConfirm }
          />
        </div>
      </div>
    </>
  );
}